import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import {
  Body,
  Children,
  CurveHolder,
  MainHolder,
} from "../../../components/common/basic";
import { Box, StyledText, BackButton } from "../../../components/common";
import { Curve, ExpandIcon, CollapseIcon } from "../../../components/svgs";

const hiw = [
  `Share your code/link with mates.`,
  `They sign up via your link/code.`,
  `Bag 1050MB data after 3 successful referrals. Friends must be under the age of 35.`,
  `Earn points for every mashup purchase your friend makes.`,
  `200 points = 100MB data.`,
  `2500 points = voucher redeemable at any MTN Customer Service Center.`,
];

const faq = [
  {
    title: `What is Pulse Referral?`,
    description: ` A Pulse feature lets you refer others to download myMTN App, scoring you 1050MB free! Plus, earn points whenever your referral buys a Mashup bundle for more data and vouchers.`,
  },
  {
    title: `How to Refer?`,
    description: `Hit the Pulse tab on myMTN App, tap Profile, then Refer Friends. Copy your link or click to share via your fave platform.`,
  },
  {
    title: `When Do I Get Free Data?`,
    description: `You'll get it immediately after 3 successful referrals.`,
  },
  {
    title: `How to Gain Points?`,
    description: `Every time your referral buys a GHC 0.05 worth of Mashup bundle, you snag 1 point.`,
  },
  {
    title: `What Can I Use Points For?`,
    description: `Redeem points for data or vouchers!`,
  },
  {
    title: `How to Redeem?`,
    description: `Under Pulse, tap Profile, then Refer Friends, and head to My Referrals. Click Redeem Points and pick your reward.`,
  },
  {
    title: `Do Points Expire?`,
    description: `Yep, if not redeemed within 90 days.`,
  },
  {
    title: `When to Redeem?`,
    description: `Once you hit 200 points or more. 200 points = 100MB data. 2500 points = GHC 100 voucher.`,
  },
];

const ReferralFAQ = () => {
  const history = useHistory();

  return (
    <>
      <MainHolder style={{ background: "white" }}>
        <Children>
          <Header background={"#E31C79"}>
            <BackButton
              onClick={() => {
                history.goBack();
              }}
            />
            <div style={{ height: 80 }}></div>
            <div style={{ marginBottom: 0 }}>
              <StyledText size={28} margin='0' color='white'>
                How it works
              </StyledText>
              <StyledText
                style={{ fontFamily: "MTNLight", marginTop: 12 }}
                size={14}
                margin='0'
                color='white'
              >
                Discover the MTN Pulse referral deal
              </StyledText>
            </div>
          </Header>
          <CurveHolder style={{ zIndex: 1, position: "relative" }}>
            <Curve fill={"white"} />
          </CurveHolder>
          <Body>
            <Box
              style={{
                padding: 20,
                backgroundColor: "transparent",
              }}
            >
              {hiw.map((point) => (
                <Box
                  style={{
                    backgroundColor: "transparent",
                    display: "flex",
                    marginBottom: 12,
                    alignItems: "start",
                  }}
                >
                  <Box style={{ backgroundColor: "transparent", padding: 5 }}>
                    <Dot />
                  </Box>
                  <StyledText
                    margin={0}
                    size={14}
                    style={{
                      fontFamily: "MTNRegular",
                      lineHeight: 1.5,
                      marginLeft: 3,
                    }}
                  >
                    {point}
                  </StyledText>
                </Box>
              ))}
            </Box>
            <div
              style={{ boxSizing: "border-box", padding: "0 15px 30px 15px" }}
            >
              {faq.map(({ title, description }, idx) => (
                <ExpandablePanel key={idx} title={title} color={"#e31c79"}>
                  <StyledText
                    size={12}
                    style={{ margin: 0, fontFamily: "MTNRegular" }}
                  >
                    {description}
                  </StyledText>
                </ExpandablePanel>
              ))}
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

export default ReferralFAQ;

const ExpandablePanel = ({ title, color, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div
      style={{
        padding: "15px 0",
        borderBottom: "1px solid #B7BABA",
        cursor: "pointer",
      }}
    >
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <StyledText
          size={12}
          style={{ margin: 0 }}
          color={isExpanded ? color : "#000"}
        >
          {title}
        </StyledText>
        {isExpanded ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <CollapseIcon fill={color} />
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <ExpandIcon fill={color} />
          </div>
        )}
      </div>
      {isExpanded && <div style={{ padding: "10px 0" }}>{children}</div>}
    </div>
  );
};

const Header = styled.div`
  overflow: hidden;
  padding: 20px 20px 80px 20px;
  background-color: ${({ background }) => background};
  position: relative;
  background-size: cover;
`;

const Dot = styled.div`
  align-self: center;
  border-radius: 12px;
  height: 12px;
  width: 12px;
  background-color: #e31c79;
`;
